import { HStack, IconButton, UseDisclosureReturn } from "@chakra-ui/react"
import Pathicon from "../pathicon/Pathicon"
import { AugmentationToolbarHookReturn } from "./AugmentationToolbar"
import AugmentationToolbarBreadcrumbs from "./AugmentationToolbarBreadcrumbs"

type AugmentationPanelNavProps = {
  toolbar: AugmentationToolbarHookReturn
  disclosure?: UseDisclosureReturn
}

const AugmentationPanelNav = ({
  toolbar,
  disclosure
}: AugmentationPanelNavProps) => {
  const { selectedOption } = toolbar

  return (
    <HStack w="100%" justifyContent="space-between" gap="5px" minW={0}>
      <AugmentationToolbarBreadcrumbs {...toolbar} />
      {!!selectedOption?.AugmentationNavComponent && (
        <HStack flexShrink={0} ml="auto">
          <selectedOption.AugmentationNavComponent option={selectedOption} />
        </HStack>
      )}
      {!!disclosure && (
        <IconButton
          aria-label="Close panel"
          colorPalette="blackAlpha"
          flexShrink={0}
          size="2xs"
          variant="ghost"
          onClick={disclosure.onClose}
        >
          <Pathicon icon="x" size={12} />
        </IconButton>
      )}
    </HStack>
  )
}

export default AugmentationPanelNav
